<template>
  <div class="collectioneditor">
    <div class="collectioneditor__header">
      <div class="collectioneditor__header__left">
        <h1 class="medium-title">Collection Editor</h1>
      </div>
      <div class="collectioneditor__header__right">
        <button @click.stop="gotoDetail" class="btn-regular secondary">Preview</button>
      </div>
    </div>
    <div class="collectioneditor__content">
      <div class="collectioneditor__content__left">
        <div class="collectioneditor__content__left__about">
          <div class="collectioneditor__content__left__about__title">
            <h3>About collection</h3>
          </div>
          <div class="collectioneditor__content__left__about__form">
            <div class="collectioneditor__content__left__about__form__top">
              <adx-input :label="`Collection Name`" :value.sync="item.title" :error.sync="inputNameError" :validation="['NotEmpty', 'MaxLength:40']" :validationMethod="'onChange'" />
              <adx-input :label="`Remarks`" :value.sync="item.remarks" />
            </div>
            <div class="collectioneditor__content__left__about__form__bottom">
              <adx-textarea :label="`Collection Description`" :value.sync="item.description" :error.sync="inputDescError" :validation="['NotEmpty', 'MaxLength:80']" />
            </div>
          </div>
        </div>
        <div class="collectioneditor__content__left__media">
          <div class="editor__content__media">
            <span class="strong">Media</span>
            <div class="editor__content__media__items">
              <div class="editor__content__media__items__landscape" @click.stop="chooseMedia('landscape')">
                <div class="editor__content__media__items__landscape__content_wrapper">
                  <img v-if="!selectedLandscape" class="empty" :src="`/img/notfound/img-placeholder-landscape@2x.png`" alt="">
                  <img v-else :src="selectedLandscape" alt="">
                </div>
                <div class="info">
                  <span class="strong">Landscape Media</span>
                  <p class="desktop">Size recomended 1040 x 440 px</p>
                  <div class="mobile">
                    <p>Size recomended</p>
                    <p>1040 x 440 px</p>
                  </div>
                </div>
              </div>
              <div class="editor__content__media__items__square" @click.stop="chooseMedia('square')">
                <div class="editor__content__media__items__landscape__content_wrapper">
                  <img v-if="!selectedSquare" :src="`/img/notfound/img-placeholder-square@2x.png`" alt="">
                  <img v-else :src="selectedSquare" alt="">
                </div>
                <div class="info">
                  <span class="strong">Square Media</span>
                  <p class="desktop">Size recomended 500 x 500 px</p>
                  <div class="mobile">
                    <p>Size recomended</p>
                    <p>500 x 500 px</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="collectioneditor__content__right">
        <div class="collectioneditor__content__right__totallisting">
          <div class="collectioneditor__content__right__totallisting__header">
            <div class="title">
              <h3>Total Listing</h3>
            </div>
            <div class="count">
              {{item.item_count}} Items
            </div>
          </div>
          <div class="collectioneditor__content__right__totallisting__view">
            <button class="btn-small secondary" @click.stop="toggleViewAll">Edit</button>
            <button class="btn-small primary" @click.stop="addmore">Add</button>
          </div>
        </div>
        <div class="collectioneditor__content__right__visibility">
          <div class="collectioneditor__content__right__visibility__header">
            <h3>Collection Visibility</h3>
          </div>
          <div class="collectioneditor__content__right__visibility__dropdown">
            <adx-selectdropdown :value.sync="item.visibility" :label="`Visibility`" :options="dropdown" />
          </div>
        </div>
        <div class="collectioneditor__content__right__action">
          <button class="btn-regular primary loading" @click.stop="submitData" :disabled="submitIsLoading || (notValidName || notValidDesc)">
            Publish
            <adx-loading-secondary v-if="submitIsLoading" slot="loading" />
          </button>
        </div>
      </div>
    </div>
    <modal v-if="isOpenViewAll" @modal-close="toggleViewAll" :type="`large`">
      <div slot="content" class="content">
        <div class="content__header">
          <h3 class="small-title">{{item.title}}</h3>
          <p class="total">total Listing {{item.item_count}} Items</p>
        </div>
        <div v-if="isLoadingListings" class="content__listings__loading">
          <adx-loading slot="loading" />
        </div>
        <template v-else>
          <div class="content__listings__actions">
            <button class="btn-regular primary" @click.stop="addmore">Add more</button>
          </div>
          <div class="content__listings__content">
            <div class="content__listings__content__list" v-for="(category, index) in selectedLists" :key="index">
              <div class="content__listings__content__list__header">
                <h2 class="small-title">{{category.title | capitalizing}}</h2>
              </div>
              <adx-list-item :category="category.title.toLowerCase()" :items='category.items' @reloadData="reloadDataSelectedDevice"/>
            </div>
          </div>
        </template>
      </div>
    </modal>
    <modal
      v-if="mediaModal"
      type="large"
      title="Choose Media File"
      @modal-close="closeMediaModal"
    >
      <div slot="content" class="media_editor">
        <div class="media_editor__menu">
          <span :class="['medialib', modalMediaTab == 'media' ? 'active' : '']" @click.stop="changeMediaTab('media')" class="subhead">Media Library</span>
          <span :class="['localfile', modalMediaTab == 'localfile' ? 'active' : '']" @click.stop="changeMediaTab('localfile')" class="subhead">Local File</span>
        </div>
        <div class="media_editor__content">
          <adx-other-media v-if="modalMediaTab == 'media'" :orientation="orientationOnModal" :is-modal="true" @selected="setMedia" />
          <adx-other-upload v-if="modalMediaTab == 'localfile'" @done="changeMediaTab('media')" :orientation="orientationOnModal" />
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import SelectDropdown from '@/components/Form/SelectDropdown'
import Input from '@/components/Form/Input'
import Textarea from '@/components/Form/TextArea'
import FormAbstraction from '@/components/Form'
import Modal from '@/components/Modal'
import ListItem from '@/views/Collection/CollectionEditor/ListItem'
import OtherMediaLibrary from '@/views/OtherMedia'
import OtherUpload from '@/views/OtherUpload'
import LoadingSpinner from '@/components/Loading/Secondary'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import types from '@/lib/types'
const {
  ButtonType: { BUTTON, RESET },
  ButtonAction: { SUBMIT, APICALL, GOTO }
} = types


export default {
  name: 'adx-collection-editor',
  components: {
    'adx-form-abstraction': FormAbstraction,
    'adx-selectdropdown': SelectDropdown,
    'modal': Modal,
    'adx-list-item': ListItem,
    'adx-input': Input,
    'adx-textarea': Textarea,
    'adx-other-media': OtherMediaLibrary,
    'adx-other-upload': OtherUpload,
    'adx-loading-secondary': LoadingSpinner,
  },
  props: {

  },
  data() {
    return {
      isOpenViewAll: false,
      wrapper: {
        alertWrapper: `content`
      },
      model: {
        name: ``,
        description: ``
      },
      error: {

      },
      onSubmit: {
        wrapper: {
          class: `button-group inline`
        }
      },
      schema: [
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Collection Name',
              model: 'name',
              method: 'onChange',
              validation: ['NotEmpty']
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'textarea',
              inputType: 'text',
              label: 'Collection Description',
              model: 'description',
              method: 'onChange',
              validation: ['NotEmpty']
            }
          ]
        }
      ],
      dropdown: [
        {
          label: 'Public',
          value: 'Public',
          helper: true
        },
        {
          label: 'Private',
          value: 'Private',
          helper: false
        }
      ],
      item: {
        title: '',
        description: '',
        visibility: '',
        remarks: ''
      },
      headers: [
        'items',
        'placement',
        'daily visitor',
        'price'
      ],
      mediaModal: false,
      modalMediaTab: 'media',
      inputNameError: '',
      inputDescError: '',
      selectedLandscape: null,
      selectedPortrait: null,
      selectedSquare: null,
      submitIsLoading: false,
      notValidName: true,
      notValidDesc: true,
      unselectedItems: [],
      selectedItems: [],
      selectedLists: [],
      isLoadingListings: false
    }
  },
  computed: {

  },
  watch: {
    inputNameError() {
      this.notValidName = this.inputNameError
    },
    inputDescError() {
      this.notValidDesc = this.inputDescError
    }
  },
  beforeCreate() {

  },
  created() {
    this.loadData()
    this.loadDataDevice()
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    toggleViewAll() {
      this.isOpenViewAll = !this.isOpenViewAll
    },
    addmore() {
      (async () => {
        this.submitIsLoading = true
        const id = this.$route.params.id
        const body = {
          title: this.item.title,
          description: this.item.description,
          visibility: this.dropdown.filter(x => x.value === this.item.visibility).pop().helper,
          remarks: this.item.remarks
        }
        const { data } = await api.patch(apiV2.collectionDetail(id), body, { needToken: true })
        this.submitIsLoading = false
        this.$router.push({ name: 'collectionaddmore', params: { id: this.$route.params.id }})
      })();
    },
    reloadDataSelectedDevice() {
      this.$nextTick(function () {
        this.loadData()
        this.loadDataDevice()
      })
    },
    loadDataDevice() {
      (async () => {
        const id = this.$route.params.id
        const { data } = await api.get(apiV2.collectionUnelectedDevice(id), { needToken: true })

        this.unselectedItems = data.results

      })();
      (async () => {
        const id = this.$route.params.id
        const { data } = await api.get(apiV2.collectionSelectedDevice(id), { needToken: true })

        this.selectedItems = data
        this.mappingSelectedDevices()
      })();
    },
    mappingSelectedDevices (category=null) {
      let list = this.selectedItems
      this.selectedLists = []
      Object.keys(list).map((key, index) => {
        if (list[key].length > 0) {
          if (category) {
            if (category == key) {
              this.selectedLists.push({
                title: key.charAt(0).toUpperCase() + key.substr(1),
                items: list[key]
              })
            }
          } else {
            this.selectedLists.push({
              title: key.charAt(0).toUpperCase() + key.substr(1),
              items: list[key]
            })
          }
        }
      })
    },
    loadData() {
      (async () => {
        const id = this.$route.params.id
        const { data } = await api.get(apiV2.collectionDetail(id), { needToken: true })

        if (data.title) {
          this.inputNameError = false
        }
        if (data.description) {
          this.inputDescError = false
        }
        this.item.title = data.title
        this.item.description = data.description
        this.item.visibility = data.status
        this.item.item_count = data.item_count
        this.selectedLandscape = data.landscape_thumbnail
        this.selectedSquare = data.square_thumbnail
      })();
    },
    submitData() {
      (async () => {
        this.submitIsLoading = true
        const id = this.$route.params.id
        const body = {
          title: this.item.title,
          description: this.item.description,
          visibility: this.dropdown.filter(x => x.value === this.item.visibility).pop().helper,
          remarks: this.item.remarks
        }
        const { data } = await api.patch(apiV2.collectionDetail(id), body, { needToken: true })
        this.submitIsLoading = false
        this.$router.push({ name: 'collectionlist' })
      })();
    },
    chooseMedia(orientation) {
      this.orientationOnModal = orientation
      this.openMediaModal()
    },
    openMediaModal() {
      this.mediaModal = true
    },
    closeMediaModal() {
      this.mediaModal = false
    },
    setMedia(item, remove=false) {
      (async () => {
        // this.isLoadingListings = true
        let orientation = item.orientation_display.toLowerCase()
        if (orientation == 'landscape') {
          this.selectedLandscape = item.thumbnail
        } else if (orientation == 'portrait') {
          this.selectedPortrait = item.thumbnail
        } else {
          this.selectedSquare = item.thumbnail
        }
        let body = {
          image: item.id
        }
        if (remove) body['remove'] = true
        const { data } = await api.patch(`v2/collection/${this.$route.params.id}/image/`, body, { needToken: true })
        this.closeMediaModal()
        // this.isLoadingListings = false
      })();
    },
    changeMediaTab(selected) {
      this.modalMediaTab = selected
    },
    gotoDetail() {
      const id = this.$route.params.id
      let routeData =  this.$router.resolve({name: 'collectiondetail', params: {id : id}})
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>